import { Portal } from '@mui/material'
import EmojiData from '@web-lite/emoji-mart-data/sets/14/apple.json'
// @ts-ignore
import Picker from '@web-lite/emoji-mart-react'

import './emojiPicker.style.css'
import { useIsFullscreenEnabled } from 'weblite-web/src/logic/fullscreen/fullscreen-mode'

//  TODO: We should remove this and use emojiPickerPopover instead.
export function EmojiPicker({
  isOpen,
  i18n,
  onClickAway,
  addEmoji,
}: {
  isOpen?: boolean
  i18n?: Record<string, any>
  onClickAway: () => unknown
  addEmoji: (emoji: string) => unknown
}) {
  const midSectionIsFullscreen = useIsFullscreenEnabled()
  if (!isOpen) return null

  return (
    <Portal>
      <div
        style={{
          direction: 'ltr',
          position: 'fixed',
          left: 5,
          bottom: 69,
          zIndex: midSectionIsFullscreen ? 12 : 5,
        }}
      >
        <Picker
          data={EmojiData}
          set="apple"
          i18n={i18n}
          perLine={8}
          emojiSize={24}
          theme="light"
          previewPosition="none"
          navPosition="bottom"
          onEmojiSelect={({ native }: { native: string }) => addEmoji(native)}
          onClickOutside={onClickAway}
          getSpritesheetURL={(set: string) => {
            console.log('emoji | config:', window.config)
            return window.config?.frontend.EMOJI_SPRITE_SHEET?.replace(
              /{EMOJI_SET}/g,
              set,
            )
          }}
        />
      </div>
    </Portal>
  )
}

EmojiPicker.defaultProps = {
  i18n: undefined,
  isOpen: false,
}
